import { Link } from "react-router-dom";
import { FaGoogle, FaLinkedin, FaXTwitter } from "react-icons/fa6";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import img1 from "../../assets/images/instai.svg";
import img2 from "../../assets/images/fbi.svg";
import img3 from "../../assets/images/linkedini.svg";
import img4 from "../../assets/images/xi.svg";

export default function Fotter({ setFooterData }) {
  let CompanyName = localStorage.getItem("branchname");
  return (
    <>
      {CompanyName !== "" ? (
        <footer
          className="footer-main mt-auto"
          style={{
            background: setFooterData?.footerColor
              ? setFooterData?.footerColor
              : "#2f408f",
          }}
        >
          <div className="container">
            <div className="row mb-4">
              <div className="col-md-7 mb-md-0 mb-3 d-flex justify-content-md-start justify-content-center">
                <ul className="footer-links nav">
                  {setFooterData?.termsconditions !== null && (
                    <li>
                      <Link
                        to={"/" + CompanyName + "/termsandcondition"}
                        className="nav-link"
                      >
                        Terms & Conditions
                      </Link>
                    </li>
                  )}
                  {setFooterData?.privacypolicy !== null && (
                    <li>
                      <Link
                        to={"/" + CompanyName + "/privacypolicy"}
                        className="nav-link"
                      >
                        Privacy policy
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
              <div className="col-md-5 d-flex justify-content-md-end justify-content-center">
                <div className="social-icons-main">
                  {setFooterData?.sociallinks && (
                    <>
                      {setFooterData?.sociallinks?.fb !== null ? (
                        <a
                          href={setFooterData?.sociallinks?.fb}
                          className="social-link"
                        >
                          <img src={img2} alt="" className="img-fluid" />
                        </a>
                      ) : (
                        ""
                      )}
                      {setFooterData.sociallinks?.insta !== null ? (
                        <a
                          href={setFooterData?.sociallinks?.insta}
                          className="social-link"
                        >
                          <img src={img1} alt="" className="img-fluid" />
                        </a>
                      ) : (
                        ""
                      )}
                      {setFooterData?.sociallinks?.twitter !== null ? (
                        <a
                          href={setFooterData?.sociallinks?.twitter}
                          className="social-link"
                        >
                          <img src={img4} alt="" className="img-fluid" />
                        </a>
                      ) : (
                        ""
                      )}
                      {setFooterData?.sociallinks?.lk !== null ? (
                        <a
                          href={setFooterData?.sociallinks?.lk}
                          className="social-link"
                        >
                          <img src={img3} alt="" className="img-fluid" />
                        </a>
                      ) : (
                        ""
                      )}
                      {/* {setFooterData?.sociallinks?.google !== null ? (
                    <a
                      href={setFooterData?.sociallinks?.google}
                      className="social-link"
                    >
                     <FaGoogle  />

                    </a>
                  ) : (
                    ""
                  )} */}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-md-6 mb-md-0 mb-4 d-flex justify-content-md-start justify-content-center">
                {" "}
                Copyright © 2025{" "}
                {localStorage.getItem("branchname")?.toUpperCase()} . All Rights
                Reserved .
              </div>
              <div className="col-md-6 d-flex justify-content-md-end justify-content-center">
                <div className="d-flex align-items-center justify-content-md-end">
                  Powered by{" "}
                  <a
                    className="copy-link ml-1 font-bold"
                    href="http://www.membroz.com/"
                  >
                    {/* <img src="https://res.cloudinary.com/dlopjt9le/image/upload/v1586525260/mlh7afpkmoldnuo3qltc.png" alt="" className="img-fluid" />  */}
                    &nbsp;Membroz
                  </a>
                </div>
              </div>
            </div>
          </div>
        </footer>
      ) : (
        ""
      )}
    </>
  );
}
